
import { defineComponent } from 'vue'
import { useProfile } from '@/composables/useProfile'

export default defineComponent({
  name: 'AppDraweMobile',

  setup() {
    const { profile, signOut } = useProfile()

    const menuList = [
      {
        label: 'Logga ut',
        icon: 'mdi-logout-variant',
        action: onSignOut,
        separator: true,
      },
    ]

    function onSignOut() {
      profile.value = null
      signOut()
    }

    return { onSignOut, menuList, profile }
  },
})
